import { createFileRoute, useParams } from "@tanstack/react-router";
import { z } from "zod";
import { UserDetailPage } from "@/components/crud/UserDetailPage";

export const Route = createFileRoute("/admin/_layout/users_/$id")({
  validateSearch: z.object({
    tab: z.string().min(1).catch("profile").default("profile"),
    // The router's search decoder turns a raw `?edit=true` into the boolean
    // `true` before it reaches here, so this covers both the table's typed
    // navigation and bookmarked/shared URLs. UserDetailPage consumes it once
    // and strips it from the URL.
    edit: z.boolean().optional().catch(undefined),
  }),
  component: AdminUserDetail,
});

function AdminUserDetail() {
  const { id } = useParams({ from: "/admin/_layout/users_/$id" });
  const { tab, edit } = Route.useSearch();
  return <UserDetailPage userId={id} activeTab={tab} editParam={edit} />;
}
